var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import React, { useState } from 'react';
import isFunction from 'lodash/isFunction';
import isBoolean from 'lodash/isBoolean';
import isString from 'lodash/isString';
import { useTheme } from './useTheme';
import { XIcon, XLoader } from '../../ui';
import { XR } from '..';
import { isNumber } from '../util/isNumber';
export function useInput(input) {
    var theme = useTheme();
    var initialValue = input.initialValue, helperText = input.helperText, errorText = input.errorText, validate = input.validate, prepend = input.prepend, append = input.append, nullable = input.nullable, label = input.label, isLoading = input.isLoading, inputProps = __rest(input, ["initialValue", "helperText", "errorText", "validate", "prepend", "append", "nullable", "label", "isLoading"]);
    if (isLoading) {
        inputProps.disabled = true;
    }
    var type = inputProps.type;
    var inputType = input.type;
    if (type === 'currency') {
        inputType = 'number';
    }
    var _a = useState((type === 'currency' && input.initialValue && Number(input.initialValue) / 100) || input.initialValue), valueDisplay = _a[0], setValueDisplay = _a[1];
    var _b = useState([]), changes = _b[0], setChanges = _b[1];
    var _c = useState(false), isChanged = _c[0], setIsChanged = _c[1];
    var value = valueDisplay;
    if (type === 'number' || type === 'currency') {
        var change = changes[0] || '';
        var prev1 = changes[1] || '';
        var prev2 = changes[2] || '';
        var isAdd = prev1.length > prev2.length;
        var isDelete = prev1.length < prev2.length;
        if (changes.length === 0) {
        }
        else if (!change && prev1.length > 1 && prev2.length > 1) {
            value = null;
        }
        else if (!change && isDelete && prev1.length === 1) {
            value = null;
        }
        else if (isAdd && !change) {
            if (prev1 === '0') {
                value = 0;
            }
            else {
                value = Number(prev1);
            }
        }
        else if (!change && isDelete) {
            value = Number(prev1.split('.')[0]);
        }
        else if (change) {
            value = Number(change);
        }
        else {
            value = null;
        }
        if (type === 'currency' && isNumber(value)) {
            value = value * 100;
        }
        //console.log(`  value=${valueDisplay} | change=${change} | prev1=${prev1} | prev2=${prev2}`, changes);
    }
    function changeValue(value) {
        setValueDisplay(value);
        setIsChanged(true);
        setChanges(function (changes) { return __spreadArray([value], changes).slice(0, 10); });
    }
    var helperTextValue = isFunction(helperText) ? helperText(value) : helperText;
    var isValid = true;
    var errorTextValue = errorText;
    handleValidation(value);
    function handleValidation(value) {
        var validate = input.validate;
        if (!validate) {
            return;
        }
        var result = validate(value);
        if (isBoolean(result)) {
            isValid = result;
        }
        else {
            isValid = result.isValid;
            if (!isValid && isChanged) {
                errorTextValue = result.text;
            }
        }
    }
    function clear() {
        changeValue(null);
        setValueDisplay('');
    }
    return {
        name: input.name,
        value: value,
        isValid: isValid,
        clear: clear,
        element: (React.createElement("div", { className: 'XR-useInput' },
            React.createElement("label", null,
                React.createElement("div", { className: 'label' }, label),
                React.createElement("div", { className: 'input-container' },
                    prepend && isString(prepend) ? React.createElement(XIcon, null, prepend) : prepend,
                    React.createElement("input", __assign({}, inputProps, { type: inputType, value: valueDisplay, onChange: function (event) {
                            changeValue(event.target.value);
                        } })),
                    append && isString(append) ? React.createElement(XIcon, null, append) : append,
                    nullable && value && (React.createElement(XR.Button, { type: 'button', onClick: clear, icon: 'clear', variant: 'text', tabIndex: -1 })),
                    isLoading && (React.createElement("div", { className: 'loader' },
                        React.createElement(XLoader, null))))),
            helperTextValue && React.createElement("div", { className: 'helper' }, helperTextValue),
            errorTextValue && React.createElement("div", { className: 'error' }, errorTextValue))),
    };
}
